import { Pipe, PipeTransform } from '@angular/core';
import {
  ItemField,
  VendorField,
} from '../../../../core/infrastructure/enums/meta-data-field.enum';
import { MetaDataField } from '../../../../core/infrastructure/classes/meta-data-field';
import { GridName } from '../../forecastui/forecast-rxdata-table/forcast-rxdata-table.constant';
import { Item } from 'src/app/core/models/item';
import { Vendor } from 'src/app/core/models/vendor';
import { ServiceLevelListDisplay } from 'src/app/core/constants/service-level.constant';
import { Company } from 'src/app/core/models/company';
import isNil from 'lodash/isNil';

@Pipe({
  name: 'dataOutput'
})
export class DataOutputPipe implements PipeTransform {
  transform(
    metadataField: MetaDataField,
    dataItem: any,
    itemName: string,
    company: Company,
    trigger: any // Trigger to rerun the pipe, don't delete
  ): any {
    const value = dataItem[metadataField.field];
    let source = metadataField?.displayControl?.selectSource?.find((src) => {
      return src.val === value;
    });

    switch (true) {
      case itemName === GridName.Supplier &&
        metadataField.field === VendorField.restockModel:
        // Set default value for restock model of vendor
        source ??= metadataField?.displayControl?.selectSource?.[0];
        break;

      // Attach source of service level, lead time and order interval for Supplier
      case itemName === GridName.Supplier &&
        [
          ItemField.serviceLevel,
          ItemField.leadTime,
          ItemField.orderInterval,
        ].includes(metadataField.field as ItemField):
        return this.getFieldDisplayName(
          metadataField.field,
          null,
          dataItem,
          company
        );

      // Attach source of service level, lead time and order interval for Item
      case itemName === GridName.Item &&
        [
          ItemField.serviceLevel,
          ItemField.leadTime,
          ItemField.orderInterval,
        ].includes(metadataField.field as ItemField): {
        return this.getFieldDisplayName(
          metadataField.field,
          dataItem,
          dataItem?.vendor,
          company
        );
      }
    }

    return source?.display;
  }

  private getFieldDisplayName(
    fieldName: string,
    item: Item,
    vendor: Vendor,
    company: Company
  ) {
    let finalItem: Item | Vendor | Company = company;
    let itemName = 'Global';

    if (!isNil(vendor?.[fieldName])) {
      finalItem = vendor;
      itemName = GridName.Supplier;
    }

    if (!isNil(item?.[fieldName])) {
      finalItem = item;
      itemName = GridName.Item;
    }

    const finalValue =
      fieldName === ItemField.serviceLevel
        ? ServiceLevelListDisplay.get(finalItem[fieldName])?.numOnly
        : finalItem[fieldName];
    return `${finalValue} (${itemName})`;
  }
}
